// extracted by mini-css-extract-plugin
module.exports = {"layout":"DocLayout-module--layout--2m-0z","main":"DocLayout-module--main--3L6xJ"};